import { getQueryStringParameters } from 'owa-querystring';

export default function isFileActivation(): boolean {
    const queryParams = getQueryStringParameters();
    return queryParams['emlMsgFileActivation'] !== undefined;
}
